<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-align: center;">Terry Endacott gained an MA from the University of East Anglia. He worked for many years in education before leaving the profession to devote more time to writing, playing music and travelling. His writing genres include imaginative fantasy for both adults and older children.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?0c607e90